<template>
  <div class="common-page order-review">
    <div class="left-box-content">
      <div class="search-form-box">
        <custom-tab-box
          class="tab-box"
          :tab-data="tabData"
          @change="handleChange"
        ></custom-tab-box>
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="5">
              <el-form-item label="下单时间:">
                <custom-date-range
                  :start-date="searchForm.startTime"
                  :end-date="searchForm.endTime"
                  @update:startDate="(val) => (searchForm.startTime = val)"
                  @update:endDate="(val) => (searchForm.endTime = val)"
                ></custom-date-range>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="订单来源:" prop="orderSource">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.orderSource"
                  filterable
                  allow-create
                  default-first-option
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in $dict.orderSourceOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="装货地:" prop="deptIds">
                <el-cascader
                  style="width: 100%"
                  v-model="searchForm.deptIds"
                  :options="deptList"
                  clearable
                  :show-all-levels="false"
                  :props="{
                    checkStrictly: true,
                    value: 'deptId',
                    label: 'deptName',
                  }"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="卸货地:" prop="deptIds">
                <el-cascader
                  style="width: 100%"
                  v-model="searchForm.deptIds"
                  :options="deptList"
                  clearable
                  :show-all-levels="false"
                  :props="{
                    checkStrictly: true,
                    value: 'deptId',
                    label: 'deptName',
                  }"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-button
                  type="primary"
                  round
                  icon="el-icon-search"
                  @click="handleCheck()"
                ></el-button>
                <el-button
                  type="default"
                  round
                  icon="el-icon-refresh"
                  @click="handleReset()"
                ></el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <div
        class="custom-table-box"
        v-loading="tableOptions.loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255,255,255,0.8)"
      >
        <div
          class="table-list"
          :class="item.userId === selectOrderId ? 'table-list-select' : ''"
          v-for="(item, index) in 5"
          :key="item.userId"
          @click="handleSelectOrder(item, index)"
        >
          <div class="list-top">
            <div class="list-top-left">
              <div class="left-box">
                <div class="left-box-top">
                  <div class="label zhuang">装</div>
                  <div class="name">南京玄武区</div>
                </div>
                <div class="date">02-24 10:30-11:00</div>
              </div>
              <div class="left-box">
                <div class="left-box-top">
                  <div class="label zhuang">装</div>
                  <div class="name">南京玄武区</div>
                </div>
                <div class="date">02-24 10:30-11:00</div>
              </div>
              <div class="left-box">
                <div class="left-box-top">
                  <div class="label xie">卸</div>
                  <div class="name">南京玄武区</div>
                </div>
                <div class="date">02-24 10:30-11:00</div>
              </div>
            </div>
            <div class="list-top-right">
              <div class="right-money">
                <span class="money">3000.00</span>
                <span class="unit">元/趟</span>
              </div>
              <div class="right-box2">
                <div class="right-box2-time">02-09 12:30</div>
                <div><span class="sty1">客户代下单</span></div>
                <!--                <div><span class="sty2">散客下单</span></div>-->
              </div>
            </div>
          </div>
          <div class="list-bottom">
            <div class="list-bottom-box">
              <div class="bottom-box-name">订单归属</div>
              <div class="bottom-box-value">渠道商A</div>
            </div>
            <div class="list-bottom-box">
              <div class="bottom-box-name">物品</div>
              <div class="bottom-box-value">门窗</div>
            </div>
            <div class="list-bottom-box">
              <div class="bottom-box-name">重量</div>
              <div class="bottom-box-value">20吨</div>
            </div>
            <div class="list-bottom-box">
              <div class="bottom-box-name">体积</div>
              <div class="bottom-box-value">2㎡</div>
            </div>
            <div class="list-bottom-box">
              <div class="bottom-box-name">包装方式</div>
              <div class="bottom-box-value">吨包</div>
            </div>
            <div class="list-bottom-box">
              <div class="bottom-box-name">用车要求</div>
              <div class="bottom-box-value">整车</div>
            </div>
            <div class="list-bottom-box">
              <div class="bottom-box-name">车型</div>
              <div class="bottom-box-value">厢式货车</div>
            </div>
            <div class="list-bottom-box">
              <div class="bottom-box-name">车长</div>
              <div class="bottom-box-value">9.6米</div>
            </div>
          </div>
          <div class="car-box" v-if="selectTab === 2">
            <div class="list-1">
              <el-image :src="cheImage" class="label-img"></el-image>
              <span class="center-name">川C52222</span>
            </div>
            <div class="list-2">王大帅</div>
            <div class="list-3">15928585007</div>
            <div class="list-2">9.6米</div>
            <div class="list-3">厢式货车</div>
          </div>
        </div>
      </div>
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleSizeChange"
          :current-page="tableOptions.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="tableOptions.pageSize"
          background
          layout="total, prev, pager, next, sizes, jumper"
          :total="tableOptions.total"
        />
      </div>
    </div>
    <div class="line-separate"></div>
    <div class="right-box">
      <div class="right-top">
        <div class="right-title">
          <el-image :src="cheImage" class="title-label"></el-image>指派给调度
        </div>
        <div class="right-title-tip">列表中仅展示了符合订单条件的司机信息</div>
        <div class="top-check">
          <div
            class="check-tab"
            @click="selectTabDriver('myDriver')"
            :class="selectDriverLabel === 'myDriver' ? 'check-tab-select' : ''"
          >
            平台司机
          </div>
          <div
            class="check-tab"
            @click="selectTabDriver('allDriver')"
            :class="selectDriverLabel === 'allDriver' ? 'check-tab-select' : ''"
          >
            临调司机
          </div>
        </div>
        <el-input
          class="right-search"
          style="width: 100%"
          clearable
          v-model="searchForm.keyword"
          autocomplete="off"
          suffix-icon="el-icon-search"
          placeholder="请输入调度姓名或手机号码"
        ></el-input>
        <div class="sort-car">
          <custom-sort-box
            :sort-data="sortData"
            @sortChange="handleSortChange"
          ></custom-sort-box>
        </div>
      </div>
      <div class="right-center-box">
        <div
          class="center-box"
          v-for="(item, index) in userList"
          :key="item.id"
          :class="item.id === selectUserId ? 'selectTab' : ''"
          @click="handleClick(item, index)"
        >
          <div class="center-box-name">
            <div class="left-box">
              <div class="center-box-1">
                <span class="label-name">王</span>
                <span class="center-name">{{ item.name }}</span>
              </div>
              <div class="center-box-2">渠道商A司机</div>
              <div class="center-box-2">累计派单16</div>
              <div class="center-box-2">累计收入1022.33元</div>
            </div>
            <div class="center-box-3">
              <i
                class="el-icon-success"
                :class="
                  item.id === selectUserId ? 'selected-icon' : 'default-icon'
                "
              ></i>
            </div>
          </div>
          <div class="center-box-car">
            <div class="car-list">
              <div class="center-box-2">苏A52555</div>
              <div class="center-box-2">厢式货车</div>
              <div class="center-box-2">9.6米</div>
              <div class="center-box-2">
                剩余容量：<span class="color52C41A">12方/30吨</span>
              </div>
            </div>
            <div class="car-list">
              <div class="center-box-2">
                上次上报时间：<span class="color52C41A"
                  >2025-02-22 00:43于南京市玄武区</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="load-box">
          <div class="load-none" v-if="isOver">已经到底了!</div>
          <div
            class="load-more"
            v-else
            @click="loading ? '' : handleLoadMore()"
          >
            <span v-if="loading"><i class="el-icon-loading"></i></span>
            <span v-else>点击加载更多</span>
          </div>
        </div>
      </div>
      <div class="right-bottom-operate">
        <el-button type="default" @click="handleReset()">取消</el-button>
        <el-button type="primary" @click="handleCheck()">确定指派</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import { downloadTable, getPage } from "./api";
import tableMixin from "@/mixin/tableMixin";
import { getTree } from "@/views/commonApi";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
import CustomSortBox from "@/components/customComponents/CustomSortBox.vue";

export default {
  name: "OrderManagement",
  mixins: [tableMixin],
  components: {
    CustomTabBox,
    CustomSortBox,
    OperateBox,
    CustomTable,
    CustomDateRange,
  },
  data() {
    return {
      loading: false,
      cheImage: require("@/assets/imgs/title.png"),
      selectTab: null,
      selectDriverLabel: "myDriver",
      isOver: false,
      tabData: [
        {
          label: 1,
          value: "订单找车",
        },
        {
          label: 2,
          value: "车辆补仓",
        },
      ],
      getTableMethod: getPage,
      downloadFileMethod: downloadTable,
      searchForm: {
        keyword: "",
        startTime: "",
        terminalType: "1",
        deptId: "",
        deptIds: [],
        endTime: "",
        sourceType: "1",
      },
      userList: [
        {
          id: 1,
          name: "王大发",
          phone: "0123456789",
          selected: false,
        },
        {
          id: 2,
          name: "王小发",
          phone: "15928585003",
          selected: true,
        },
        {
          id: 3,
          name: "王小发",
          phone: "15928585006",
          selected: false,
        },
        {
          id: 4,
          name: "王小发",
          phone: "15928585004",
          selected: false,
        },
        {
          id: 5,
          name: "王小发",
          phone: "15928585004",
          selected: false,
        },
        {
          id: 6,
          name: "王小发",
          phone: "15928585004",
          selected: false,
        },
        {
          id: 7,
          name: "王小发",
          phone: "15928585004",
          selected: false,
        },
        {
          id: 8,
          name: "王小发",
          phone: "15928585004",
          selected: false,
        },
        {
          id: 9,
          name: "王小发",
          phone: "15928585004",
          selected: false,
        },
      ], // 调度人员列表
      deptList: [],
      isImmediatelyGetData: true,
      selectOrderId: "",
      selectUserId: "",
      sortData: [
        {
          name: "派单量",
          key: "pdl",
          value: "",
        },
        {
          name: "收入",
          key: "sr",
          value: "",
        },
        {
          name: "上报时间",
          key: "sbsj",
          value: "",
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleSortChange(obj) {
      // // console.log("obj", obj);
    },
    handleLoadMore() {
      this.loading = true;

      setTimeout(() => {
        this.loading = false;
        this.userList = this.userList.concat(this.userList);
        this.isOver = true;
      }, 2000);
    },
    selectTabDriver(val) {
      this.selectDriverLabel = val;
    },
    handleChange(val) {
      this.selectTab = val;
    },
    getTree() {
      getTree().then((res) => {
        if (res.code === 200) {
          this.deptList = res.data;
        }
      });
    },
    handleClick(item, index) {
      this.selectUserId = item.id;
    },
    handleSelectOrder(item, index) {
      this.selectOrderId = item.userId;
    },
  },
};
</script>
<style lang="scss" scoped>
.order-review {
  display: flex;
  height: 100%;
  overflow: hidden;
  flex-direction: row;

  .left-box-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    .custom-table-box {
      //max-height: 90%;
      overflow-y: auto;
      padding-top: 0;

      .table-list {
        width: 100%;
        background: #fbfcff;
        margin-bottom: 0.2rem;
        padding: 0.12rem 0.1rem;
        box-sizing: border-box;
        border: 0.01rem solid #fbfcff;
        border-radius: 0.08rem;
        cursor: pointer;
        .list-top {
          display: flex;
          justify-content: space-between;
          .list-top-left {
            display: flex;
            .left-box {
              padding-right: 0.5rem;
              position: relative;
              .left-box-top {
                display: flex;
                align-items: center;
                .label {
                  width: 0.2rem;
                  height: 0.2rem;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 0.02rem;
                  font-size: 0.12rem;
                }
                .zhuang {
                  color: #5cc41a;
                  background-color: rgba(92, 196, 26, 0.3);
                }
                .xie {
                  color: #e52019;
                  background-color: rgba(229, 32, 25, 0.3);
                }
                .name {
                  color: #000000;
                  font-size: 0.18rem;
                  line-height: 0.2rem;
                  padding-left: 0.04rem;
                }
              }
              .date {
                color: #8c8c8c;
                font-size: 0.12rem;
                line-height: 0.2rem;
              }
            }
            .left-box::before {
              content: "→";
              position: absolute;
              right: 0.15rem;
              top: 0.04rem;
              color: #52c41a;
            }
            .left-box:nth-last-of-type(1)::before {
              display: none;
            }
          }
          .list-top-right {
            .right-money {
              display: flex;
              justify-content: right;
              align-items: baseline;
              color: #faad14;
              .money {
                font-size: 0.18rem;
              }
              .unit {
                font-size: 0.12rem;
                padding-left: 0.04rem;
              }
            }
            .right-box2 {
              display: flex;
              align-items: center;
              .right-box2-time {
                font-size: 0.12rem;
                line-height: 0.2rem;
                color: #8c8c8c;
                margin-right: 0.1rem;
              }
              .right-box2-label {
                background-color: #fff7e6;
                color: #fa8c16;
                font-size: 0.12rem;
                line-height: 0.22rem;
                border-radius: 0.1rem;
                padding: 0 0.1rem;
              }
            }
          }
        }
        .list-bottom {
          width: 100%;
          display: flex;
          padding: 0.12rem 0;
          .list-bottom-box {
            width: 15%;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            .bottom-box-name {
              color: #8c8c8c;
              font-size: 0.12rem;
              margin-bottom: 0.1rem;
            }
            .bottom-box-value {
              color: #434343;
              font-size: 0.14rem;
            }
          }
          .list-bottom-box::before {
            content: "";
            position: absolute;
            right: 0;
            top: 0.08rem;
            width: 0.01rem;
            height: 0.26rem;
            background-color: #dce5f5;
          }
          .list-bottom-box:nth-last-of-type(1)::before {
            display: none;
          }
        }
        .car-box {
          display: flex;
          align-items: center;
          border-top: 0.01rem dashed #dce5f5;
          padding: 0.1rem 0 0;
          .list-1 {
            display: flex;
            align-items: center;

            .label-img {
              width: 0.14rem;
              height: 0.14rem;
            }
            .center-name {
              line-height: 0.2rem;
              padding-left: 0.04rem;
              font-size: 0.14rem;
              color: #52c41a;
            }
          }
          .list-2,
          .list-3 {
            font-size: 0.12rem;
            color: #8c8c8c;
          }
          .list-2 {
            padding: 0 0.2rem;
            position: relative;
            &::before {
              content: "";
              width: 0.01rem;
              height: 0.1rem;
              background-color: #dce5f5;
              position: absolute;
              left: 0.1rem;
            }
            &::after {
              content: "";
              width: 0.01rem;
              height: 0.1rem;
              background-color: #dce5f5;
              position: absolute;
              right: 0.1rem;
            }
          }
        }
      }
      .table-list-select {
        border-color: #1269ff;
        background-color: rgba(18, 105, 255, 0.05);
      }
    }
    .pagination-box {
      display: flex;
      justify-content: right;
      padding: 0.2rem 0.2rem 0.2rem 0;
    }
  }
  .line-separate {
    width: 0.01rem;
    height: calc(100% - 0.4rem);
    background-color: rgba(220, 229, 245, 0.5);
    box-sizing: border-box;
    margin: 0.2rem 0.2rem 0.2rem 0;
  }
  .right-box {
    width: 28%;
    height: 100%;
    flex-shrink: 0;

    display: flex;
    flex-direction: column;
    padding-right: 0.2rem;
    box-sizing: border-box;
    .right-top {
      box-sizing: border-box;
      flex-shrink: 0;
      background-color: #ffffff;
      .right-title {
        padding: 0.2rem 0 0;
        .title-label {
          width: 0.08rem;
          height: 0.08rem;
          margin-right: 0.06rem;
        }
      }
      .right-title-tip {
        color: rgba(0, 0, 0, 0.25);
        font-size: 0.12rem;
        line-height: 0.2rem;
        padding: 0.1rem 0;
      }
      .right-search {
        margin: 0.15rem 0 0;
      }
      .sort-car {
        padding: 0.1rem 0;
      }
    }
    .right-center-box {
      flex: 1;
      overflow-y: auto; /* 允许垂直滚动 */
      box-sizing: border-box;

      .center-box {
        width: 100%;
        background-color: #fbfcff;
        border-radius: 0.08rem;
        padding: 0 0.1rem;
        box-sizing: border-box;
        cursor: pointer;
        margin-bottom: 0.2rem;
        border: 0.01rem solid #fbfcff;
        .center-box-name {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0.1rem 0;
          .left-box {
            display: flex;
            align-items: center;
            .center-box-1 {
              display: flex;
              align-items: center;
              .label-name {
                width: 0.24rem;
                height: 0.24rem;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #1269ff;
                font-size: 0.12rem;
                background-color: rgba(18, 105, 255, 0.05);
              }
              .center-name {
                line-height: 0.2rem;
                padding-left: 0.04rem;
              }
            }
            .center-box-2 {
              display: flex;
              align-items: center;
              line-height: 0.24rem;
              color: #000000;
              font-size: 0.12rem;
              position: relative;
            }
            .center-box-2 {
              padding-left: 0.2rem;
              position: relative;
              &::before {
                content: "";
                width: 0.01rem;
                height: 0.1rem;
                background-color: #dce5f5;
                position: absolute;
                left: 0.1rem;
              }
            }
          }

          .center-box-3 {
            flex-shrink: 0;
            line-height: 0.2rem;
            font-size: 0.16rem;
            .default-icon {
              color: #eeeeee;
            }
            .selected-icon {
              color: #52c41a;
            }
          }
        }
        .center-box-car {
          border-top: 0.01rem dashed #dce5f5;
          .car-list {
            display: flex;
            align-items: center;
            padding: 0.1rem 0;
            .center-box-2 {
              padding-right: 0.2rem;
              color: #8c8c8c;
              position: relative;
              font-size: 0.12rem;
              &::before {
                content: "";
                width: 0.01rem;
                height: 0.1rem;
                background-color: #dce5f5;
                position: absolute;
                right: 0.1rem;
                top: 0.02rem;
              }
            }
            .center-box-2:nth-last-of-type(1)::before {
              display: none;
            }
          }
        }
      }
      .selectTab {
        border: 0.01rem solid #1269ff;
      }
    }
    .right-bottom-operate {
      width: 100%;
      flex-shrink: 0;
      position: sticky;
      bottom: 0rem;
      background-color: #ffffff;
      display: flex;
      justify-content: right;
      padding: 0.15rem 0;
      box-sizing: border-box;
      border-top: 0.01rem solid #e3e7ed;
    }
  }
  .tab-box {
    margin-bottom: 0.2rem;
  }
}
</style>
